export enum SessionStorageKey {
	SalesforceCodeVerifier = 'salesforceCodeVerifier'
}
